<template>
  <div class="clean-solution-page">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/banner_clean.png"
        class="pc-banner"
        alt="光伏智能清洗"
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/banner_clean.png"
        class="mobile-banner"
        alt="光伏智能清洗"
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          光伏智能清洗
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          焱图慧云依托“无人机+机器人+AI平台”的全栈技术能力，打造空地协同、软硬一体的智能清洗方案，为光伏电站提供从“人工定期清洗”到“智能按需清洗”的全面升级
        </div>
      </div>
    </div>

    <div class="block-wrap industry-block">
      <div class="industry-title page-block-title">传统清洗方式及问题</div>
      <div class="industry-content">
        <div
          class="industry-item"
          v-for="(item, index) in problemList"
          :key="index"
        >
          <img :src="item.image" alt="" />
          <div class="text-block">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="block-wrap solution-wrap">
      <div class="block-title page-block-title">解决思路</div>
      <div class="block-desc">
        焱图慧云光伏智能清洗方案，以无人机或地面机器人为载体，融合路径规划，为各类光伏电站提供高效、安全、便捷的自动化清洗服务。一键下发任务，清洗设备按预设航线自动覆盖全站组件。传统人工清洗：耗时数周、耗费大量人员
        → 焱图方案：几小时完成，极大节省了人力。
      </div>
      <div class="flow-content">
        <template v-for="(step, index) in flowList">
          <div class="flow-step">
            <img :src="step.bg" class="flow-bg" alt="" />
            <div class="flow-info">
              <div class="flow-head">
                <div class="flow-num">{{ step.num }}</div>
                <div class="flow-title">{{ step.title }}</div>
              </div>
              <div class="flow-desc">{{ step.desc }}</div>
            </div>
          </div>
          <img
            v-if="index < flowList.length - 1"
            :key="'arrow-' + index"
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_flow_arrow.png"
            class="flow-arrow"
            alt=""
          />
        </template>
      </div>
    </div>

    <div class="advantage-wrap">
      <div class="advantage-content">
        <div class="block-title page-block-title mb-47">我们的优势</div>

        <div
          class="block-row"
          v-for="(item, index) in advantageList"
          :key="index"
          :class="{ reverse: index % 2 === 1 }"
        >
          <div
            class="block-media wow"
            :class="index % 2 === 0 ? 'fadeInLeft' : 'fadeInRight'"
          >
            <img :src="item.image" alt="" />
          </div>
          <div
            class="block-text wow"
            :class="index % 2 === 0 ? 'fadeInRight' : 'fadeInLeft'"
          >
            <div class="block-content-title">{{ item.title }}</div>
            <div class="block-content-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="product-wrap">
      <div class="product-title page-block-title">相关产品</div>
      <div class="product-list">
        <div
          class="product-card"
          v-for="(item, index) in productList"
          :key="index"
          @click="goProduct(item.path)"
        >
          <div class="product-img">
            <img :src="item.image" :alt="item.title" />
          </div>
          <div class="product-info">
            <div class="product-name">{{ item.title }}</div>
            <div class="product-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-bottom-space"></div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {
      problemList: [
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_img1_clean.png",
          title: "人工清洗慢，效率低",
          desc: "一座中型电站清洗需数十人耗时数周，人工成本高昂，且清洗频次难以保障",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_img2_clean.png",
          title: "高空作业险，安全难保",
          desc: "高处电站，人工攀爬清洗存在坠落风险；地面电站大面积作业体力消耗大",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_img3_clean.png",
          title: "地形复杂，清洗受限",
          desc: "农光互补、渔光互补、山地电站等，传统清洗设备难以进入，运维压力大",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_img4_clean.png",
          title: "效果难量化，价值说不清",
          desc: "清洗前后缺乏数据对比，发电量提升多少无法精确评估",
        },
      ],
      flowList: [
        {
          num: "01",
          bg: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_flow_bg1.png",
          title: "规划清洗路径",
          desc: "智能算法自动规划最优清洗路径，无人机规划空中航线，机器人规划地面路线，适应各类电站布局。",
        },
        {
          num: "02",
          bg: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_flow_bg2.png",
          title: "下达清洗任务",
          desc: "远程一键下发指令，设备即刻响应，任务状态实时可查，支持单次或周期任务。",
        },
        {
          num: "03",
          bg: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_flow_bg3.png",
          title: "执行清洗命令",
          desc: "无人机/机器人按照规划好的路径自动执行清洗任务，全程自动作业，实时响应。",
        },
        {
          num: "04",
          bg: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_flow_bg4.png",
          title: "发电量数据监测",
          desc: "清洗后持续监测发电量变化，对比清洗前后数据，量化清洗收益，验证清洗效果。",
        },
      ],
      advantageList: [
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_advantage1_clean.png",
          title: "两种清洗模式，全场景覆盖",
          desc: "无人机适用于高危屋顶、山地、水面等复杂地形；机器人适用于平铺类地面电站。两种模式按需选择，全场景覆盖。",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_advantage2_clean.png",
          title: "效率跃升 · 自动清洗",
          desc: "无需人工攀爬或地面徒步，无人机/机器人自动作业。单次清洗周期从数周压缩至数小时，效率提升5倍以上。",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_advantage3_clean.png",
          title: "安全可靠 · 绿色环保",
          desc: "无人机空中清洗，杜绝高空坠落风险；机器人沿组件自主行进，避免人工滑倒、中暑等隐患。两种方式均将人员与危险环境隔离，让清洗作业更安全、更安心。",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fan_advantage4_clean.png",
          title: "收益可量化 · 价值可见",
          desc: "清洗前后自动生成对比报告，发电量提升精确量化。投资回报清晰，业主决策有据可依。",
        },
      ],
      productList: [
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_img1_clean.png",
          title: "福宝[轻洁]系列SR103",
          desc: "福宝[轻洁] SR103 光伏清洗机器人，机身 19kg 快拆设计，单人转场无压力。最大 20° 大倾角爬坡，电站场景更全适配。定速遥控 + 声光报警防坠落，全天稳定作业。",
          path: "/product/cleaning-robot",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_img2_clean.png",
          title: "福宝[轻洁]系列SR202",
          desc: "福宝[轻洁] SR202 光伏清洗机器人，双刷增效，轻量护板！机身仅 18kg，刷头单重9kg，分体搬运不伤光伏板。300米单手遥控 + 全向防坠落，作业无忧。",
          path: "/product/cleaning-robot-sr202",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_img3_clean.png",
          title: "福宝[智洁]系列ASR102",
          desc: "福宝[智洁] ASR102 全自动光伏清洗机器人，AI 全自动无人作业：RTK 精准导航，自主清扫、自动无线回充，夜间可运行。多重安全保障：云端远程监控 + 全向防坠落，户外全天候稳定作业。",
          path: "/product/cleaning-robot-asr102",
        },
        {
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_img4_clean.png",
          title: "SC-50清洗无人机",
          desc: "SC-50清洗无人机：碳纤维航空铝机身，载重50L，支持系留/水箱双供水，水压5-15MPa可调。Z字折叠便携，适用各类电站及高空外墙清洗，安全高效。",
          path: "/product/cleaning-drone",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    goProduct(path) {
      if (path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.clean-solution-page {
  width: 100%;

  @keyframes zoomIn {
    0% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }

  .layout-banner {
    position: relative;
    height: 100vh;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      animation: zoomIn 3s ease-out forwards;
    }

    .pc-banner { display: block; }
    .mobile-banner { display: none; }

    .text-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      color: #fff;
      text-align: center;

      .title {
        font-size: 3rem;
        letter-spacing: 2px;
        font-weight: bold;
        margin-bottom: 1.44rem;
      }

      .desc {
        letter-spacing: 2px;
        width: 52rem;
        max-width: 90vw;
        font-size: 1.25rem;
        line-height: 2.2rem;
      }
    }
  }

  .industry-block {
    max-width: var(--main-width);
    width: 84%;
    margin: 5rem auto 4rem;

    .industry-title {
      text-align: center;
    }

    .industry-content {
      display: flex;
      margin-top: 3.06rem;
      gap: 1.5rem;

      .industry-item {
        flex: 1;
        min-width: 0;

        img {
          width: 100%;
          height: auto;
          margin-bottom: 0.875rem;
          border-radius: 4px;
        }

        .text-block {
          text-align: center;

          .title {
            font-size: 1.375rem;
            font-weight: bold;
            margin-bottom: 10px;
            color: #333;
          }

          .desc {
            color: #666;
            font-size: 0.875rem;
            line-height: 1.5rem;
          }
        }
      }
    }
  }

  .solution-wrap {
    background: linear-gradient(180deg, rgba(206, 228, 255, 0) 0%, #EFF4FF 100%);
    padding: 4rem 0 5rem;

    .block-title {
      text-align: center;
    }

    .block-desc {
      max-width: var(--main-width);
      width: 45%;
      margin: 1.5rem auto 3rem;
      text-align: center;
      color: #666;
      font-size: 1rem;
      line-height: 1.8rem;
    }

    .flow-content {
      max-width: var(--main-width);
      width: 84%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .flow-step {
      position: relative;
      width: 15rem;
      flex-shrink: 0;

      .flow-bg {
        width: 100%;
        display: block;
      }

      .flow-info {
        position: absolute;
        left: 10%;
        right: 10%;
        top: 38%;
        text-align: left;
      }

      .flow-head {
        display: flex;
        align-items: center;
        margin-bottom: 1.25rem;

      }

      .flow-num {
        flex-shrink: 0;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background: #2372E9;
        color: #fff;
        font-size: 0.75rem;
        font-weight: bold;
        line-height: 1.5rem;
        text-align: center;
        margin-right: 0.4rem;
      }

      .flow-title {
        font-size: 1.375rem;
        font-weight: bold;
        color: #333;
        line-height: 1.5rem;
        white-space: nowrap;
      }

      .flow-desc {
        font-size: 0.875rem;
        color: #666;
        line-height: 1.25rem;
      }
    }

    .flow-arrow {
      margin: 0 0.4rem;
      flex-shrink: 0;
      margin-top: -1.5rem;
    }
  }

  .advantage-wrap {
    padding: 5rem 0 2rem;

    .advantage-content {
      max-width: var(--main-width);
      width: 84%;
      margin: 0 auto;
    }

    .block-title {
      text-align: center;
    }

    .mb-47 {
      margin-bottom: 2.93rem;
    }

    .block-row {
      display: flex;
      align-items: center;
      margin-bottom: 4.5rem;
      gap: 3rem;

      &.reverse {
        flex-direction: row-reverse;
      }

      .block-media {
        flex: 1.2;
        min-width: 0;

        img {
          width: 100%;
          display: block;
        }
      }

      .block-text {
        flex: 1;
        min-width: 0;
      }

      .block-content-title {
        font-size: 1.75rem;
        font-weight: bold;
        color: #2372E9;
        margin-bottom: 1.5rem;
      }

      .block-content-desc {
        color: #333;
        font-size: 1rem;
        line-height: 1.8rem;
      }
    }
  }

  .product-wrap {
    background: #F5F7FA;
    padding: 3rem 0 6rem;

    .product-title {
      text-align: center;
      margin-bottom: 3rem;
    }

    .product-list {
      max-width: 68.75rem;
      width: 72%;
      margin: 0 auto;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap:3.75rem 4.6rem;
    }

    .product-card {
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      aspect-ratio: 440 / 480;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      transition: transform 0.25s ease, box-shadow 0.25s ease;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

        .product-info {
          .product-name {
            color: #2372E9;
          }
        }
      }

      .product-img {
        width: 100%;
        flex: 1;
        min-height: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        padding: 1.25rem 1.5rem 0;
        box-sizing: border-box;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .product-info {
        flex-shrink: 0;
        padding: 1rem 1.75rem 1.75rem;
        box-sizing: border-box;

        .product-name {
          font-size: 1.25rem;
          font-weight: bold;
          color: #333;
          margin-bottom: 0.75rem;
          line-height: 1.4;
          transition: color 0.25s ease;
        }

        .product-desc {
          font-size: 0.875rem;
          color: #666;
          line-height: 1.6rem;
        }
      }
    }
  }

  .page-bottom-space {
    width: 100%;
    height: 16.75rem;
    background: #fff;
  }
}

@media only screen and (max-width: 1200px) {
  .clean-solution-page {
    .solution-wrap {
      .flow-content {
        flex-wrap: wrap;
        gap: 1.5rem;
      }

      .flow-arrow {
        display: none;
      }

      .flow-step {
        width: calc(50% - 1rem);
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .clean-solution-page {
    .layout-banner {
      height: 380px;
      margin-top: 108px;

      .pc-banner { display: none; }
      .mobile-banner { display: block; }

      .text-block {
        width: 85%;

        .title {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .desc {
          width: 100%;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

    .industry-block {
      width: calc(100% - 30px);
      margin: 40px auto 30px;

      .industry-content {
        flex-wrap: wrap;
        gap: 20px;
        margin-top: 20px;

        .industry-item {
          flex: 0 0 calc(50% - 10px);
        }
      }
    }

    .solution-wrap {
      padding: 30px 15px 40px;

      .block-desc {
        width: 100%;
        margin: 16px 0 24px;
        font-size: 14px;
        line-height: 22px;
        text-align: left;
      }

      .flow-content {
        width: 100%;
      }

      .flow-step {
        width: calc(50% - 8px);

        .flow-info {
          top: 36%;
        }

        .flow-num {
          width: 1.25rem;
          height: 1.25rem;
          line-height: 1.25rem;
          font-size: 0.625rem;
          margin-right: 0.25rem;
        }

        .flow-title {
          font-size: 13px;
          white-space: normal;
          line-height: 1.25rem;
        }

        .flow-desc {
          font-size: 11px;
          line-height: 16px;
        }
      }
    }

    .advantage-wrap {
      padding: 30px 0 10px;

      .advantage-content {
        width: calc(100% - 30px);
      }

      .block-row {
        flex-direction: column !important;
        gap: 16px;
        margin-bottom: 36px;

        .block-content-title {
          font-size: 20px;
          margin-bottom: 12px;
        }

        .block-content-desc {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

    .product-wrap {
      padding: 30px 15px 40px;

      .product-list {
        width: 100%;
        max-width: none;
        grid-template-columns: 1fr;
        gap: 16px;
      }

      .product-card {
        aspect-ratio: auto;

        .product-img {
          padding: 12px 12px 0;
          flex: none;
          aspect-ratio: 440 / 480;
        }

        .product-info {
          padding: 12px 16px 20px;

          .product-name {
            font-size: 1.125rem;
          }
        }
      }
    }

    .page-bottom-space {
      height: 52px;
    }
  }
}
</style>
